<script>
import { authComputed, authMethods, orgComputed, orgMethods } from '@state/helpers';

export default {
  name: 'LoginMobile',
  components: {},
  data() {
    return {
      username: '',
      password: '',
      emailError: null,
      passError: null,
      authenticating: false,
    };
  },
  computed: {
    ...authComputed,
    ...orgComputed,
    colors() {
      return {
        '--color': this.primaryColor,
      };
    },
    logoUrl() {
      return process.env.VUE_APP_ORG_ID === '618183d65e84466f63c38878'
        ? 'https://tandem-email.s3.amazonaws.com/pmeo-logo-light.png'
        : 'https://tandem-email.s3.amazonaws.com/smartfitness-logo.png';
    },
  },
  methods: {
    ...authMethods,
    ...orgMethods,
    handleAuthErrors(err) {
      console.log(err);
      this.authenticating = false;
      this.emailError = '';
      this.passError = err;
    },
    formValid() {
      this.emailError = null;
      this.passError = null;
      if (this.username && this.password) {
        return true;
      } else {
        if (!this.password || this.password === '') {
          this.passError = `Password can't be blank`;
        }
        if (!this.username || this.username === '') {
          this.emailError = `Email can't be blank`;
        } else if (!this.username.includes('@')) {
          this.emailError = `A valid email address is required`;
        }
        return false;
      }
    },
    handleLogin() {
      if (this.formValid()) {
        this.authenticating = true;
        this.logIn({
          username: this.username,
          password: this.password,
        })
          .then((loginResponse) => {
            this.authenticating = false;

            this.$router.push(this.$route.query.redirectFrom || { name: 'home' });
          })
          .catch((err) => this.handleAuthErrors(err));
      }
    },
  },
  watch: {
    username(val) {
      if (this.emailError) {
        this.emailError = null;
      }
    },
    password(val) {
      if (this.passError) {
        this.passError = null;
      }
    },
  },
};
</script>

<template>
  <div class="container">
    <div class="background">
      <router-link class="to-root" to="/">
        <img svg-inline :src="logoUrl" />
      </router-link>
      <div>
        <h1>Welcome back!</h1>
        <p>Sign in to your account.</p>
      </div>
    </div>
    <div class="form">
      <form @submit.prevent="handleLogin">
        <BaseInputText :class="{ error: emailError }" type="email" classStyle="user" placeholder="Email" v-model="username" />
        <p class="errorMsg" v-if="emailError">{{ emailError }}</p>

        <BaseInputText
          :class="{ error: passError }"
          autocomplete
          type="password"
          classStyle="password"
          placeholder="Password"
          v-model="password"
        />
        <p class="errorMsg" v-if="passError">{{ passError }}</p>
        <div class="forgot-password">
          <router-link class="btn-forgot-password" to="/reset-password"> Forgot your password? </router-link>
        </div>
        <div class="sign-in">
          <BaseButton class="large" type="submit">Sign In</BaseButton>
        </div>
      </form>
      <!-- <div class="other-info">
        <p>
          Don't have an account?
          <router-link class="links" to="/signup">Sign Up</router-link> and
        </p>
      </div> -->
      <div class="other-info">
        <p>
          By logging in, you agree to the
          <a class="links" target="_blank" :style="colors" href="/privacy">Privacy Policy</a>
          and
          <a class="links" target="_blank" :style="colors" href="/terms">Terms of Use.</a>
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.container {
  display: flex;
  flex-flow: column;
  height: 100%;
  max-width: unset !important;
  width: 100%;
  .background {
    background: url('~@assets/images/backgrounds/mobile/onboarding-sign-in.jpg') no-repeat;
    background-position: 0% 0%;
    background-size: cover;
    border: 0;
    display: flex;
    flex: 2 1 auto;
    flex-direction: column;
    justify-content: space-between;
    margin: 0;
    position: relative;
    width: 100%;
    .to-root {
      align-items: center;
      align-self: center;
      display: flex;
      justify-content: center;
      margin-left: auto;
      margin-right: auto;
      padding-top: 10.3%;
      width: 47%;
      img {
        align-self: center;
        margin-bottom: auto;
        margin-left: auto;
        margin-right: auto;
        padding-top: 17.3%;
        width: 159.23px;
      }
    }

    h1 {
      color: white;
      font-family: $base-font-family;
      font-size: 35px;
      margin: 0;
      margin-left: 7%;
      margin-top: auto;
      text-align: left;
      white-space: nowrap;
      width: 70%;
    }
    p {
      color: white;
      font-family: $secondary-font-family;
      font-size: 1.5em;
      margin: 0;
      margin-left: 7%;
      margin-top: 0.15%;
      padding-bottom: 4.25%;
      text-align: left;
    }
  }

  .form {
    background: white;
    flex: 0.3 1 auto;
    padding-top: 4rem;
    width: 100%;
    .input-wrapper {
      width: 100%;
      ::v-deep input {
        border-radius: unset;
        &.password {
          border-radius: unset;
        }
      }
      &.error {
        ::v-deep input {
          margin-bottom: unset;
        }
      }
    }

    .errorMsg {
      border-color: #fd5252;
      border-width: 0.2rem;
      color: red;
      margin-bottom: 4.8%;
      margin-bottom: 1rem;
      margin-left: auto;
      margin-right: auto;
      text-align: center;
      width: 80%;
    }

    .forgot-password {
      margin: 5px 10% auto auto;
      padding-bottom: 10%;
      text-align: right;
      .btn-forgot-password {
        color: black;
        font-family: $secondary-font-family;
        text-decoration: none;
      }
    }

    .sign-in {
      align-self: flex-end;
      margin-left: 6.4%;
      width: 87.2%;
    }
  }

  .other-info {
    display: flex;
    height: 25%;
    justify-content: center;
    padding-top: 10px;
    width: 100%;

    p {
      font-family: $secondary-font-family;
      height: 100%;
      line-height: 1.4;
      text-align: center;
      width: 82%;

      .links {
        color: var(--color);
        text-decoration: none;
      }
    }
  }
}
</style>
